import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';

export interface AddIdentificationUploadLegitimationProps {
  AddIdentificationForm: any;
  onUploadDocument: (doc: any) => void;
}

const AddIdentificationUploadLegitimation: FunctionComponent<AddIdentificationUploadLegitimationProps> = (props) => {
  const { AddIdentificationForm, onUploadDocument } = props;

  return (
    <>
      <p>
        <strong>
          <Translate name="dashboardIssuerInvestorDetails.addIdentificationForm.subtitleUploadDocument" />
        </strong>
      </p>
      <AddIdentificationForm.Group name="legitimationProtocol" required={true}>
        <AddIdentificationForm.FileUpload onChange={onUploadDocument} />
      </AddIdentificationForm.Group>
    </>
  );
};

export default AddIdentificationUploadLegitimation;
